import React, { FC } from 'react';
import { Web, ArrowDown1 } from '@kl/icons/16';
import { resolveLanguageLocPath } from '@next/shared';
import { useLocalizationContext } from 'shared/lib/localization';
import { StyledButtonContent, StyledButtonText, StyledChangeLanguageButton } from './styled';

export const ChangeLanguageButton: FC = () => {
    const { language } = useLocalizationContext();

    return (
        <StyledChangeLanguageButton testId="changeLanguage" mode="secondary">
            <StyledButtonContent>
                <Web />
                <StyledButtonText localizationKey={resolveLanguageLocPath(language)} />
                <ArrowDown1 />
            </StyledButtonContent>
        </StyledChangeLanguageButton>
    );
};
